import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withButtonColor from '../../hoc/with-button-color';
import styles from './floating-create-button.scss';

const FloatingCreateButton = ({ buttonColor, ...otherProps }) => {
  const className = classNames(
    styles.button,
    'floating-create-button',
    'default-button-background-color',
    'button-primary-icon-fill'
  );
  const buttonProps = omit(
    otherProps,
    'forPublicUser',
    'currentUser',
    'isBlocked',
    'isOwner',
    'isPrivate',
    'dispatch',
    'viewMode',
    'isDemoMode',
    'openModal',
    'isAuthenticated'
  );

  return <span className={className} style={{ backgroundColor: buttonColor }} {...buttonProps}/>;
};

FloatingCreateButton.propTypes = {
  buttonColor: PropTypes.string.isRequired,
};

export default withButtonColor(FloatingCreateButton);



// WEBPACK FOOTER //
// ./app/components/floating-create-button/floating-create-button.js